var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('el-header',[_c('sidebarLogo',{attrs:{"isCollapse":_vm.isCollapse}})],1),_c('el-main',[_c('el-scrollbar',{attrs:{"wrap-class":"scrollbar-wrapper"}},[_c('Emun')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }